import _ from 'lodash'
import { getShipTypeIdFromAllValues } from './ReduxFormSelectors/ProposalListingForm'
import { PRODUCT_SHIP_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'

/**
 * 取出 listing 中第一個 model 的 videos，
 * videos 位置會因為是否有 models 而不同
 *
 * @param {listing} 賣場
 */
export const getFirstOrderVideos = listing => {
  // 是否為有屬性賣場
  const models = _.get(listing, 'models', null)
  const hasModels = !_.isEmpty(models)

  const videos = hasModels
    ? models[0].videos
    : listing.videos

  return videos
}

/**
 * 判斷賣場的屬性商品是否為有效賣場(規格表一致且非電子票券)
 */
export const getUpdateListingModelValidateResult = (listing) => {
  const struIdField = 'struDataAttrClusterId'
  const dataList = _.get(listing, 'productStructuredDataList', [])
  const uniqStruIds = _.flow(
    () => _.uniqBy(dataList, struIdField),
    uniqDataList => _.map(uniqDataList, struIdField)
  )()
  const listingStruId = _.get(listing, `skuDetail.${struIdField}`)
  // 檢視賣場過期查無賣場時 productStructuredDataList 會是空的，
  // 檢視狀態不需要再驗證規格表一致，因為他曾經送出成功代表驗證是正確的
  const isInConsistentListing = (_.size(uniqStruIds) > 1)
  // 賣場裡 skuDetail 有提供 struDataAttrClusterId 才驗證是否規格表不一致
  // https://jira.vzbuilders.com/browse/APACSMDESK-56908
  const isInConsistentProduct = _.isEmpty(listingStruId)
    ? false
    : !_.isEqual(_.first(uniqStruIds), listingStruId)
  const isInConsistentProductListing = (isInConsistentListing || isInConsistentProduct)
  // 判斷是否為電子票券
  const isEVoucher = (
    getShipTypeIdFromAllValues({ product: _.get(listing, 'skuDetail', {}) }, true) ===
    PRODUCT_SHIP_TYPE.E_VOUCHER
  )
  const isValid = (
    !isEVoucher &&
    !isInConsistentProductListing
  )
  return { isValid, isInConsistentProductListing, isEVoucher }
}
